import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const Blogs = () => {
  const [blogs, setBlogs] = useState([]);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const blogsPerPage = 6;

  /* ================= FETCH BLOGS FROM BACKEND ================= */
  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const res = await  fetch("https://thakkar-backend.vercel.app/api/blogs");

        const data = await res.json();

        if (data.success && data.data.length > 0) {
          setBlogs(data.data); // ✅ MongoDB blogs
        } 
        
      } catch (error) {
        console.error("Using fallback blog data");
      
      }
    };

    fetchBlogs();
  }, []);

  /* ================= SEARCH ================= */
  const filteredBlogs = blogs.filter((blog) =>
    blog.title.toLowerCase().includes(search.toLowerCase())
  );

  /* ================= PAGINATION ================= */
  const lastIndex = currentPage * blogsPerPage;
  const firstIndex = lastIndex - blogsPerPage;
  const currentBlogs = filteredBlogs.slice(firstIndex, lastIndex);
  const totalPages = Math.ceil(filteredBlogs.length / blogsPerPage);

  return (
    <div className="min-h-screen bg-gray-100 py-12 px-4 mt-32">
      <div className="max-w-7xl mx-auto">

        {/* HEADER */}
        <div className="text-center mb-8">
          <h1 className="text-3xl font-bold">Real Estate Blogs</h1>
          <p className="text-gray-500 mt-2">
            Property tips, insights & market trends
          </p>
        </div>

        {/* SEARCH */}
        <div className="mb-8 max-w-md mx-auto">
          <input
            type="text"
            placeholder="Search blogs..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full px-4 py-2 border rounded-lg outline-none focus:ring-2 focus:ring-black"
          />
        </div>

        {/* BLOG GRID */}
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
          {currentBlogs.map((blog) => (
            <div
              key={blog._id}
              className="bg-white rounded-xl shadow hover:shadow-lg transition overflow-hidden"
            >
              <img
                src={blog.image}
                alt={blog.title}
                className="h-52 w-full object-cover"
              />

              <div className="p-5">
                <div className="flex justify-between text-sm text-gray-500 mb-2">
                  <span>{blog.date}</span>
                  <span>{blog.readTime}</span>
                </div>

                <h2 className="text-lg font-semibold mb-2">
                  {blog.title}
                </h2>

                <p className="text-sm text-gray-600 line-clamp-3">
                  {blog.content}
                </p>

                <Link
                  to={`/blog/${blog._id}`}
                  className="inline-block mt-4 text-blue-600 font-medium"
                >
                  Read More →
                </Link>
              </div>
            </div>
          ))}
        </div>

        {/* PAGINATION */}
        {totalPages > 1 && (
          <div className="flex justify-center gap-3 mt-10">
            {[...Array(totalPages)].map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentPage(index + 1)}
                className={`px-4 py-2 rounded-lg border ${
                  currentPage === index + 1
                    ? "bg-black text-white"
                    : "bg-white"
                }`}
              >
                {index + 1}
              </button>
            ))}
          </div>
        )}

      </div>
    </div>
  );
};

export default Blogs;
